export const STATSIG_CLIENT_KEY =
    'client-eQuZOzz7D7TWsrZtXEXGjLrsvFEvt7IJ3yQHf66gW3B';

export const STATSIG_OVERRIDE_PARAM = 'overrideStatsig';

// Floating number, range from 0 to 100
// By default, there won't be any sampling for clients.
export const DEFAULT_SAMPLE_RATE = 100;
